import { createNativeStackNavigator } from '@react-navigation/native-stack';
import React from 'react';
import { SafeAreaView, StyleSheet } from 'react-native';

import { useStyles } from '~/hooks';
import { Theme } from '~/theme';
import AIStrategiesListScreen from '../screens/AIStrategiesListScreen';
import AIStrategyDetailsScreen from '../screens/AIStrategyDetailsScreen';
import CreateAIStrategyScreen from '../screens/CreateAIStrategyScreen';

const Stack = createNativeStackNavigator();

// The 3-route target shape from docs/ai-strategy/01-navigation-and-screens.md. Mobile only —
// desktop hosts the same screens as a plain pane (AIStrategyPane).
export default function AIStrategyStackNavigator() {
    const styles = useStyles(stylesGenerator);

    return (
        <SafeAreaView style={styles.container}>
            <Stack.Navigator
                initialRouteName="AIStrategiesList"
                // Each screen renders its own CustomHeader, so the stack supplies none. That is
                // what lets these screens also be hosted outside a navigator.
                screenOptions={{ headerShown: false }}
            >
                <Stack.Screen name="AIStrategiesList" component={AIStrategiesListScreen} />
                <Stack.Screen name="AIStrategyDetails" component={AIStrategyDetailsScreen} />
                <Stack.Screen name="CreateAIStrategy" component={CreateAIStrategyScreen} />
            </Stack.Navigator>
        </SafeAreaView>
    );
}

const stylesGenerator = (theme: Theme) =>
    StyleSheet.create({
        container: { flex: 1 },
        headerBackground: { backgroundColor: theme.backgroundSecondary },
        headerText: { color: theme.text },
    });
